import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { OrderType } from "@gql/offer";
import { BUY_ORDERS_PILL_VALUE, SELL_ORDERS_PILL_VALUE } from "@helpers/const/following-options";

@Component({
	selector: "order-action-ui",
	templateUrl: "./order-action.component.html",
	styleUrls: ["./order-action.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class OrderActionUIComponent {
	public buyPillValue = BUY_ORDERS_PILL_VALUE;
	public sellPillValue = SELL_ORDERS_PILL_VALUE;

	@Input() public orderAbTestEnabled: boolean = false;
	@Input() public showCheckOrders: boolean;
	@Input() public orderType: OrderType;
	@Input() public pillSelected: string;
	@Input() public isNewSellVisible: boolean;
	@Output() public onGoToLimitOrders = new EventEmitter<void>();
	@Output() public onCreateOrder = new EventEmitter<OrderType>();

	public createOrder(orderType?: OrderType): void {
		this.onCreateOrder.emit(orderType);
	}

	public openOrdersPage(): void {
		this.onGoToLimitOrders.emit();
	}
}
